var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18407_35214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5555 2.16675H1.44439C1.25284 2.16675 1.06914 2.24284 0.933702 2.37828C0.798259 2.51373 0.722168 2.69743 0.722168 2.88897V10.1112C0.722168 10.3027 0.798259 10.4864 0.933702 10.6219C1.06914 10.7573 1.25284 10.8334 1.44439 10.8334H11.5555C11.747 10.8334 11.9307 10.7573 12.0662 10.6219C12.2016 10.4864 12.2777 10.3027 12.2777 10.1112V2.88897C12.2777 2.69743 12.2016 2.51373 12.0662 2.37828C11.9307 2.24284 11.747 2.16675 11.5555 2.16675ZM10.9994 10.1112H2.04383L4.57161 7.49675L4.05161 6.99481L1.44439 9.69231V3.43786L5.933 7.90481C6.06832 8.03932 6.25137 8.11482 6.44217 8.11482C6.63297 8.11482 6.81602 8.03932 6.95133 7.90481L11.5555 3.32592V9.64536L8.89772 6.98758L8.38855 7.49675L10.9994 10.1112ZM1.91745 2.88897H10.9705L6.44217 7.39203L1.91745 2.88897Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18407_35214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e1dd36e34fc7db819001785a6d0d62f5.svg";
export { ForwardRef as ReactComponent };